<template>
  <div class="phone-number" :class="getValidationClasses()">
    <SelectBox v-if="isMobile" name="phonePrefix" key="phonePrefix"
      icon="v" label="Telefon*" class="selection-box--blue-border"
      v-model="phonePrefix" :options="phonePrefixOptionsForMobile" />
    <InputBox v-else icon="v" name="phonePrefix" key="phonePrefix" class="input-box--blue-border"
      label="Telefon*" :highlight="dropdowns.phone"
      v-model="selectedPhonePrefixValue" @click="toggle('phone')">
      <RadioList v-if="dropdowns.phone"
        @close="toggle('phone')" @input="$emit('input', phone)"
        :options="phonePrefixOptionsForWeb"
        v-model="phonePrefix" />
    </InputBox>

    <TextInput name="phoneNumber" placeholder="np. 123456789"
      @focus="onFocusTextInput" @blur="onBlurTextInput" @input="$emit('input', phone)"
      data-vv-validate-on="change"
      v-model="phoneNumber" validateAs="phoneNumber"
      v-validate="{ required: true, numeric: true, min: 7, regex: /^(?!(\d)\1*$)\d{7,}$/ }" />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CustomControlValidationMixin from '@/components/CustomControlValidationMixin'
import TextInput from '@/components/forms/fields/TextInput.vue'
import DropdownHandler from '@/components/search/DropdownHandler'
import RadioList from '@/components/search/fields/RadioListDropdown'
import InputBox from '@/components/search/InputBox'
import SelectBox from '@/components/search/SelectBox'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
    DropdownHandler,
    CustomControlValidationMixin,
  ],
  components: {
    SelectBox,
    TextInput,
    InputBox,
    RadioList,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    phone () {
      return `${this.phonePrefix} ${this.phoneNumber}`
    },
  },
  watch: {
    phoneNumber (val) {
      if (val) {
        this.$emit('input', `${this.phonePrefix} ${val}`)
      }
    },
    value: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          const cleanNumber = newValue.replace(/^\+48\s*/, '').replace(/^\+48\s*/, '')
          this.phonePrefix = '+48'
          this.phoneNumber = cleanNumber

          if (this.$validator) {
            this.$validator.validate('phoneNumber', this.phoneNumber)
          }
        }
      },
    },
  },
})
export default class PhoneNumber extends Vue {
  phonePrefix = '+48'
  phoneNumber = ''

  dropdowns = {
    phone: false,
  }

  get phonePrefixOptionsForMobile () {
    return this.options.map(prefix => ({ value: prefix, text: prefix }))
  }

  get phonePrefixOptionsForWeb () {
    return this.options.map(prefix => ({ value: prefix, name: prefix }))
  }

  get selectedPhonePrefix () {
    return this.phonePrefixOptionsForWeb
      .filter(prefix => prefix.value === this.phonePrefix)
      .firstOrDefault({ name: '' })
  }

  get selectedPhonePrefixValue () {
    return this.getFormatedSelectValue(this.selectedPhonePrefix.name, '')
  }

  getFormatedSelectValue (item, label, max = 1) {
    if (item == null) return label
    else if (item.length === 0) return label
    else if (typeof item === 'string' && item != '') return item
    else if (item.length <= max) return item.take(item.length).map(x => x.name).join(', ')
    else return `${item.length} wybrano`
  }

  onFocusTextInput (e) {
    return e.target.closest('.text-input').classList.add('text-input--focus')
  }

  onBlurTextInput (e) {
    return e.target.closest('.text-input').classList.remove('text-input--focus')
  }
}
</script>

<style lang="scss" scoped>
.phone-number {
  display: grid;
  grid-template-columns: 85px 1fr;
  grid-column-gap: 20px;
  align-items: start;

  .input-box {
    grid-row-end: span 1;
  }

  .text-input {
    grid-row-end: span 2;
  }
}
</style>

<style lang="scss">
.phone-number {
  &.field-invalid .input-box {
    color: #E71F6C;
    
    &__body {
      color: inherit;
      background-image: url("/assets/images/input-box-underline-red.png");
    }

    &__value-text--active {
      color: inherit;
    }
  }

  .figure {
    color: inherit;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/forms/fields/PhoneNumber.vue